"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _ampApi = require("@amplify/amp-api");

var _lodash = _interopRequireDefault(require("lodash"));

var _realtimeService = _interopRequireDefault(require("./realtimeService"));

var _constants = require("../shared/constants");

// Copyright 2019 Amplify Inc. All Rights Reserved.

/**
 * @fileoverview Service providing access to functionality for syncing autosave
 * state across a class.
 * @author jtully@amplify.com
 */
var SubmissionNotificationService = /*#__PURE__*/function () {
  function SubmissionNotificationService() {
    (0, _classCallCheck2.default)(this, SubmissionNotificationService);
  }

  (0, _createClass2.default)(SubmissionNotificationService, [{
    key: "addListener",
    value: function () {
      var _addListener = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(classKey, userKeys, cardstackKeys, callback, appName) {
        var submissionResponses, initialSubmissionArray, notificationCallback;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return Promise.all(cardstackKeys.map(function (cardstackKey) {
                  return (0, _ampApi.fetchSubmissions)(userKeys, cardstackKey, null, appName);
                }));

              case 2:
                submissionResponses = _context2.sent;
                initialSubmissionArray = _lodash.default.flatMap(submissionResponses, function (cardstackSubmissions) {
                  return _lodash.default.flatMap(cardstackSubmissions, function (userSubmissions) {
                    return Object.values(userSubmissions);
                  });
                });
                callback(initialSubmissionArray);

                notificationCallback = /*#__PURE__*/function () {
                  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(channel, payload, publisher) {
                    var submissionResponse, submissionArray;
                    return _regenerator.default.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (!(channel !== classKey || !userKeys.includes(publisher))) {
                              _context.next = 2;
                              break;
                            }

                            return _context.abrupt("return");

                          case 2:
                            if (!(!payload || !payload.cardstackKey || !cardstackKeys.includes(payload.cardstackKey))) {
                              _context.next = 4;
                              break;
                            }

                            return _context.abrupt("return");

                          case 4:
                            _context.next = 6;
                            return (0, _ampApi.fetchSubmissions)(publisher, payload.cardstackKey, null, appName);

                          case 6:
                            submissionResponse = _context.sent;
                            // convert to an array of submissions
                            // note for now there should be only one submission but sending an array gives
                            // the option of batching in the future as well as consistency with the inital submissions.
                            submissionArray = _lodash.default.flatMap(submissionResponse, function (cardstackSubmissions) {
                              return Object.values(cardstackSubmissions);
                            });
                            callback(submissionArray);

                          case 9:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function notificationCallback(_x6, _x7, _x8) {
                    return _ref.apply(this, arguments);
                  };
                }();

                _realtimeService.default.addEventListener(_constants.STUDENT_RECORD_TYPES.STUDENT_SUBMISSION, notificationCallback, callback);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function addListener(_x, _x2, _x3, _x4, _x5) {
        return _addListener.apply(this, arguments);
      }

      return addListener;
    }()
  }, {
    key: "removeListener",
    value: function removeListener(callback) {
      _realtimeService.default.removeEventListener(_constants.STUDENT_RECORD_TYPES.STUDENT_SUBMISSION, callback);
    }
  }, {
    key: "publishNotification",
    value: function publishNotification(classKey, cardstackKey, recipient) {
      return _realtimeService.default.publish(classKey, _constants.STUDENT_RECORD_TYPES.STUDENT_SUBMISSION, {
        cardstackKey: cardstackKey
      }, recipient);
    }
  }]);
  return SubmissionNotificationService;
}();

var _default = new SubmissionNotificationService();

exports.default = _default;
//# sourceMappingURL=submissionNotificationService.js.map